import {Button, Form, Modal} from 'antd';
import {AuthContext} from 'context/Auth.context';
import {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import FormGroup from 'components/formItems/FormGroup';
import Toast from 'components/Toast';
import IMG from 'assets/profile-picture.png';
import SERVICES from 'services';
import './Cards.less';
import {CandidateContext} from 'context/Candidate.context';

const MainCard = ({isProfile = false, regIsOpen}: {isProfile?: boolean; regIsOpen?: boolean}) => {
	const {state, dispatch} = useContext(CandidateContext);
	const {statusID, status, name, lastname, middleName, email, registrationNumber, curriculumPayment, path} =
		state;

	const [payModal, setPayModal] = useState(false);
	const [errors, setErrors] = useState<any>({});
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const navigate = useNavigate();

	const statusColor = {
		1: '#02081A', // grey
		2: '#CE1126', // red
		3: '#02081A', // grey
		4: '#002494', // blue
		5: '#CE1126', // red
		6: '#002494' // blue
	};

	const descriptionText = {
		1: 'ⓘ Դիմում-հայտը հաստատելուց (Submit) հետո, տվյալներն այլևս փոփոխել չեք կարող',
		2: 'ⓘ Դիմում հայտը հաստատելու և ընդունելության քննություններին մասնակցության իրավունք ստանալու համար խնդրում ենք անցնել հղումով  և վճարել',
		3: '',
		4: `${
			curriculumPayment
				? 'ⓘ Հանձնաժողովի որոշման համաձայն Դուք ընդունված եք։ Խնդրում ենք կատարել առաջին վճարումը՝ Ձեր կարգավիճակը (ուսանող) հաստատելու համար։'
				: ''
		}`,
		5: '',
		6: ''
	};

	const descriptionColor = {
		1: '#CE1126', // red
		2: '#02081A' // grey
	};

	const action = {
		1: {
			text: 'Դիմել',
			action: () => navigate('/admission', {replace: true})
		},
		2: {
			text: 'Վճարել Հիմա',
			action: () => setPayModal(true)
		},
		4: {
			text: 'Վճարել Հիմա',
			action: () => setPayModal(true)
		}
	};

	const attachPayment = async (value: any) => {
		setLoading(true);
		SERVICES.USER.payOfflie(value)
			.then(res => {
				Toast.success(res.message);
				setPayModal(false);
				SERVICES.USER.getProfile('CANDIDATE')
					.then(res => {
						dispatch({
							type: 'SET_PROFILE',
							payload: {
								name: res.data.name,
								lastname: res.data.lastname,
								middleName: res.data.middleName,
								id: res.data.id,
								path: res.data.path,
								telephone: res.data.telephone,
								email: res.data.email,
								status: res.data.status,
								statusID: res.data.statusID,
								registrationNumber: res.data.registrationNumber,
								curriculumPayment: res.data.curriculumPayment
							}
						});
					})
					.then(() => {
						setLoading(false);
					});
			})
			.catch(e => {
				setErrors(e.message);
				if (typeof e.message === 'string') {
					Toast.error(e.message);
				}
				setLoading(false);
			});
	};

	const payOnline = async () => {
		const windowRef = window.open() as Window;
		setLoading(true);
		SERVICES.USER.getPaymentLink()
			.then(res => {
				windowRef.location = res.data.paymentURL;
			})
			.catch(e => {
				setErrors(e.message);
				if (typeof e.message === 'string') {
					Toast.error(e.message);
				}
			})
			.finally(() => {
				setLoading(false);
				setPayModal(false);
			});
	};

	return (
		<>
			<div className="main-card">
				<div className="content">
					<div className="info-wrapper">
						{isProfile && (
							<div className="photo">
								<img
									src={path ? process.env.REACT_APP_API_URL + '/' + path : IMG}
									width={168}
								/>
							</div>
						)}
						<div>
							<div className="header">
								{name} {lastname}
							</div>
							<div className="info">
								<div style={{display: 'flex', flexDirection: 'column', width: 'max-content'}}>
									<div className="status">
										<span id="status">Կարգավիճակ՝ </span>
										<span
											id="status-info"
											style={{color: statusColor[statusID as 1 | 2 | 3 | 4 | 5 | 6]}}>
											{status}
										</span>
									</div>
									<div className="status" style={{width: 'max-content'}}>
										<span id="status">Էլ-փոստ՝ </span>
										<span id="status-info">{email}</span>
									</div>
									<div className="status" style={{width: 'max-content'}}>
										<span id="status">Գրանցման համար՝ </span>
										<span id="status-info">{registrationNumber}</span>
									</div>
								</div>
							</div>
						</div>
						<div
							className="description"
							style={{color: descriptionColor[statusID as 1 | 2] || 'grey'}}>
							<span>{descriptionText[statusID as 1 | 2 | 3 | 4 | 5 | 6]}</span>
						</div>
					</div>
				</div>
				{statusID === 1 || statusID === 2 || (statusID === 4 && curriculumPayment) ? (
					<div className="action-buttons">
						{regIsOpen ? (
							<Button
								type="primary"
								className="action"
								onClick={action[statusID].action}
								disabled={loading}>
								{statusID === 1 ? action[statusID].text : 'Կցել վճարման կտրոնը'}
								{/* Կցել վճարման կտրոնը
							{action[statusID].text} */}
							</Button>
						) : (
							<></>
						)}
						{statusID !== 1 && regIsOpen ? (
							<Button type="primary" className="action" onClick={payOnline} disabled={loading}>
								Վճարել առցանց
							</Button>
						) : (
							<></>
						)}
					</div>
				) : (
					<div></div>
				)}
			</div>
			<Modal
				cancelText="Չեղարկել"
				okText="Հաստատել"
				visible={payModal}
				onCancel={() => {
					setErrors({});
					setPayModal(false);
				}}
				onOk={form.submit}>
				<Form form={form} onFinish={attachPayment} layout="vertical">
					<FormGroup
						formErrors={errors}
						tabFields={[
							{
								type: 'title',
								label: 'Վճարում'
							},
							{
								type: 'file',
								label: 'Կցել վճարման կտրոնը,',
								colProps: {xs: 24, lg: 24},
								isRequired: false,
								name: 'path'
							},
							...(!curriculumPayment ? [{type: 'divider'}] : [])
						]}
					/>
					{/* {!curriculumPayment && (
						<div style={{display: 'flex', flexDirection: 'column'}}>
							<span className="pay-online">կամ վճարել առցանց</span>
							<Button type="ghost" onClick={payOnline} disabled={loading}>
								Վճարել առցանց
							</Button>
						</div>
					)} */}
				</Form>
			</Modal>
		</>
	);
};

export default MainCard;
